import { render } from "./CustomAreaManager.vue?vue&type=template&id=6efecd50&scoped=true"
import script from "./CustomAreaManager.vue?vue&type=script&lang=js"
export * from "./CustomAreaManager.vue?vue&type=script&lang=js"

import "./CustomAreaManager.vue?vue&type=style&index=0&id=6efecd50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efecd50"]])

export default __exports__